import ChangeSalesman from './ChangeSalesman'

export default ChangeSalesman
